var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.11788 16.0657L0.0954013 2.97481C0.0942835 2.32382 0.351814 1.69905 0.81134 1.23795C1.27087 0.776842 1.89474 0.517167 2.54573 0.516049L15.6366 0.49357C16.2876 0.492452 16.9124 0.749983 17.3735 1.20951C17.8346 1.66903 18.0943 2.29291 18.0954 2.9439L18.1179 16.0348C18.119 16.6858 17.8614 17.3105 17.4019 17.7716C16.9424 18.2327 16.3185 18.4924 15.6675 18.4935L2.57664 18.516C1.92565 18.5171 1.30089 18.2596 0.83978 17.8001C0.378673 17.3406 0.118998 16.7167 0.11788 16.0657ZM1.73176 2.972L1.75424 16.0629C1.75461 16.2799 1.84117 16.4878 1.99487 16.641C2.14858 16.7942 2.35683 16.88 2.57383 16.8797L7.66473 16.8709L7.63944 2.14367L2.54854 2.15241C2.33154 2.15278 2.12358 2.23934 1.97041 2.39304C1.81723 2.54675 1.73139 2.755 1.73176 2.972ZM12.1849 2.13586L12.2102 16.8631L9.30109 16.8681L9.2758 2.14086L12.1849 2.13586ZM16.4815 16.0376C16.4819 16.2546 16.396 16.4628 16.2428 16.6165C16.0897 16.7702 15.8817 16.8568 15.6647 16.8572L13.8465 16.8603L13.8212 2.13305L15.6394 2.12993C15.8564 2.12956 16.0647 2.2154 16.2184 2.36858C16.3721 2.52175 16.4586 2.72971 16.459 2.94671L16.4815 16.0376Z",
    fill: "#6D7F8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.23b56d012a042cb175bcca2aac41f28c.svg";
export { ForwardRef as ReactComponent };